<template>
    <v-container fluid>
        <!-- Search bar -->
        <v-row align="center">
            <v-col cols="12" class="text-right mb-2">
                <!-- Button to open add notice dialog -->
                <!-- <v-btn small color="primary" dark @click="openDialog">
                    <v-icon small class="mr-2">mdi-plus</v-icon>FAIRE UNE DENONCIATION
                </v-btn> -->
            </v-col>
        </v-row>

        <!-- Data table for displaying exclusions -->
        <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune dénonciation trouvée"
            :items="this.$store.getters['Auth/getDenonciation']" @click:row="goto" class="elevation-1 mb-5 px-5">
            <!-- Slot for custom row rendering -->

            <template v-slot:[`item.dateDenonciation`]="{ item }">{{
                    item.dateDenonciation | moment("DD MMMM YYYY")
                }}</template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    components: { DatePicker },
    data: () => ({
        search: "",
        dialog: false,
        headers: [
            { text: "type Dénonciation", align: "start", sortable: false, value: "typeDenonciation" },
            { text: "Objet Dénonciation", sortable: false, value: "denonciationObjet" },
            { text: "Date de Dénonciation", sortable: false, value: "dateDemande" },
        ],
    }),
    created() {
        this.$store.dispatch("Auth/loadAllDenonciation");
        this.$store.dispatch("Auth/getData");
    },
    methods: {
        ...mapActions({
            loadAllDemandeQuitus: "Auth/loadAllDenonciation",
        }),
        openDialog() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
        },
        goto(value) {
            const { id } = value;
            this.$router.push({ name: "Regshow_denonciation", params: { id: id } });
        },
    }
};
</script>

<style></style>
